import React, { useState } from "react";
import {
  TextField,
  Chip,
  makeStyles,
  Typography,
  Grid
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
  },
  search: {
  marginBottom: theme.spacing(2),
  background: "#fff",
  width: 335,
  "& .MuiOutlinedInput-root": {
    borderRadius: 6,
    height: 40, // compact height
    fontSize: "0.9rem",
  },
  "& input": {
    padding: "10px 12px",    
    height: "100%",       
    lineHeight: "36px",    
    boxSizing: "border-box",
  },
},
  chip: {
    margin: theme.spacing(0.8),
    fontWeight: 600,
    borderRadius: "20px",
    padding: "4px 8px",
    fontSize: "0.85rem",
  },
  selectedChip: {
    backgroundColor: "#00AEEF", // orange
    color: "#fff",
    "& .MuiChip-deleteIcon": {
      color: "#fff",
      fontWeight: "bold",
      marginLeft: "4px",
    },
  },
  unselectedChip: {
    backgroundColor: "#0b1c2c", // dark navy
    color: "#fff",
    "& .MuiChip-deleteIcon": {
      color: "#fff",
      fontWeight: "bold",
      marginLeft: "4px",
    },
  },
}));



export default function RoleChips(props) {
  const allRoles = props.availableRolesInAccount || [];

  const classes = useStyles();

   const [search, setSearch] = useState("");

  const handleToggle = (role) => {
    props.setEnabledRoles((prev) =>
      prev.includes(role) ? prev.filter((r) => r !== role) : [...prev, role]
    );
  };

  // Filter roles based on search text
  const filteredRoles = allRoles.filter((role) =>
    role.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className={classes.container}>
      <Typography variant="subtitle2" style={{ color: "#797979", marginLeft: '-15px',
    marginBottom: '-12px'}}>
        Assign Roles
      </Typography>
      <TextField
        className={classes.search}
        fullWidth
        variant="filled"
        placeholder="Search Roles"
        size="small"  
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        InputProps={{
          style: {
            height: 40,        
            fontSize: "0.9rem" ,
            marginLeft:'-15px',

          }
        }}
      />

      <Typography variant="subtitle2" gutterBottom>
        Matching Roles
      </Typography>
      <Grid container>
        {filteredRoles.map((tag) => {
          const isSelected = props.enabledRoles.length > 0 && props.enabledRoles.includes(tag) ? true : false ;
          return (
           <Chip
                key={tag}
                label={tag}
                onClick={() => handleToggle(tag)}
                style={{
                  margin: "6px",
                  fontWeight: 600,
                  borderRadius: "20px",
                  padding: "4px 8px",
                  fontSize: "0.85rem",
                  backgroundColor: isSelected ? "#00AEEF" : "#0b1c2c",
                  color: "#fff",
                }}
                deleteIcon={
                  <span
                    style={{
                      color: "#fff",
                      fontWeight: "bold",
                      marginLeft: "4px",
                    }}
                  >
                    {isSelected ? "✓" : "+"}
                  </span>
                }
                onDelete={() => handleToggle(tag)}
           />
  
            
          );
        })}
      </Grid>
    </div>
  );
}
